import React, { useState } from "react";
import ImagemFukyo from "../Imagem-Fukyo/Imagem-Fukyo";
import './HighLight-Item-List.scss';
import { withRouter, } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import moment from "moment";



const HighLightItemList = (props) => {

    const { conteudo, index, bsMais, alteraPosicao, excluirDestaque, total } = props;
    const [openModalExcluir, setOpenModalExcluir] = useState(false)
    // const [loadingArrow, setLoadingArrow] = useState(false)

    const toggleModalExcluir = (id) => {
        setOpenModalExcluir(!openModalExcluir)
    }

    // const editItem = (item) => {
    //     history.push(`detalhes/${item._id}`);
    // };


    return (
        <>
            <div className="col-lg-10 col-12 pt-2 mt-3 offset-lg-1 offset-0 content-product " >
                <div className="card bg-white">
                    <div className={`${bsMais ? 'bg-primary' : 'bg-purple'} text-white card-header`}>
                        <div className="row no-gutters">
                            <div className="col-12 pb-3 pb-lg-0">
                                <div className="row no-gutters">
                                    <div className="col-3 border-white">
                                        <span className="tipo-label d-flex align-items-center">
                                            {conteudo.tipoDestaque}
                                        </span>

                                    </div>
                                    <React.Fragment>
                                        <div className="col-4 d-none d-md-block text-left">
                                            {conteudo ?
                                                <span className={`badge ${conteudo.statusPublicacao === 'Agendado' ? 'badge-warning text-dark' : 'badge-success'}`}>{conteudo.statusPublicacao}</span>
                                                :
                                                <span className={`badge badge-success`}>CILE</span>}
                                        </div>
                                        <div className="col-9 col-md-5 text-right border-white d-flex justify-content-end align-items-center">
                                            {conteudo &&
                                                <>
                                                    <i className={'cursor-pointer fas fa-arrow-up icones-destaques-ativos px-3 ' + (index === 0 && 'd-none')} onClick={() => alteraPosicao(conteudo, -1)} ></i>
                                                    <i className={'cursor-pointer fas fa-arrow-down icones-destaques-ativos px-3 ' + (index === (total - 1) ? 'd-none' : null)} onClick={() => alteraPosicao(conteudo, 1)} ></i>
                                                    {/* <button className="btn btn-outline-light" type="button" onClick={() => editItem(conteudo)} >
                                                        Editar
                                                    </button> */}
                                                    <i onClick={() => toggleModalExcluir(conteudo.id)} className={`ml-4 far fa-trash-alt text-light icone-remover cursor-pointer`}></i>
                                                </>
                                            }

                                        </div>
                                    </React.Fragment>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`card-body pt-3`}>
                        <div className="card-body pt-3">
                            <div className="row no-gutters">
                                <div className="col-3 d-lg-block d-none">
                                    <ImagemFukyo
                                        className={`img img-fluid`}
                                        src={conteudo && conteudo.imagem}
                                        alt={`imagem-destaque`}
                                    />

                                </div>
                                <div className="col-lg-9 col-12  px-lg-4 px-0" >
                                    <div className="row">
                                        <div className="col-12">
                                            <>
                                                <p className="infos-ativos"><strong>Título:</strong> {conteudo.titulo}</p>
                                                <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(conteudo.dtPublicacao).format('DD/MM/YYYY')}</p>
                                            </>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={openModalExcluir} toggle={toggleModalExcluir}>
                <ModalHeader toggle={toggleModalExcluir}>
                    Excluir destaque
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12 pt-2'>
                            <p>Tem certeza que deseja excluir o destaque: <strong>{conteudo.titulo}</strong>?</p>
                        </div>

                    </div>

                </ModalBody>
                <ModalFooter>
                    <button className='btn btn-sm btn-outline-secondary' onClick={toggleModalExcluir} >
                        Cancelar
                    </button>
                    <button className='btn btn-sm btn-outline-danger' onClick={() => [excluirDestaque(conteudo), toggleModalExcluir()]} >
                        Excluir
                    </button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default withRouter(HighLightItemList);